declare const tinymce: any;
declare const jQuery: any;
const $ = jQuery;

export function initWysiwygs(): void
{
    const $wraps = $(`[data-wysiwyg]`);
    if ($wraps.length === 0)
    {
        return;
    }
    $(window).one("load", function () {
        if (typeof tinymce === "undefined")
        {
            console.error(`wysiwyg-editor error: tinymce undefined`);
            return;
        }
        $wraps.each(function () {
            initWysiwyg($(this));
        });
    });
}

function initWysiwyg($wrap, reinit: boolean = false)
{
    const editorId: string = $wrap.attr("data-editor-id");
    let editor = tinymce.editors[editorId];
    if (!editor)
    {
        console.warn(`Failed to find tinymce editor '${editorId}'`);
        return;
    }
    if (reinit)
    {
        tinymce.EditorManager.execCommand('mceRemoveEditor', true, editorId);
        tinymce.EditorManager.execCommand('mceAddEditor', true, editorId);
        editor = tinymce.editors[editorId];
        setDefaultSettings($wrap, editor);
    }
    else
    {
        setDefaultSettings($wrap, editor);
    }
}

function setDefaultSettings($wrap, editor): void {
    const defaultContent: string = $wrap.attr(`data-default-content`);
    if (defaultContent)
    {
        editor.setContent(defaultContent);
    }
    const height: number = parseInt($wrap.attr("data-height"), 10);
    if (height)
    {
        editor.theme.resizeTo(undefined, height);
    }
}

// $wraps - [data-wysiwyg] wrap elements
export function reinitWysiwygs($wraps): void
{
    if ($wraps.length === 0)
    {
        return;
    }
    if (typeof tinymce === "undefined")
    {
        console.error(`reinitWysiwygs error: tinymce undefined`);
        return;
    }
    $wraps.each(function () {
        initWysiwyg($(this), true);
    });
}

// $wrap must be the wrapper div with the data-wysiwyg && data-editor-id attributes
export function getWysiwygContent($wrap): string|undefined
{
    const editor = getWysiwygEditorInstance($wrap);
    return editor ? $.trim(editor.getContent() || "") : undefined;
}

// $wrap must be the wrapper div with the data-wysiwyg && data-editor-id attributes
// Returns TinyMCE editor instance or undefined
export function getWysiwygEditorInstance($wrap): any
{
    if (typeof tinymce === "undefined")
    {
        console.error(`getWysiwygEditorInstance() error: tinymce undefined (called too early?)`);
        return undefined;
    }
    $wrap = $($wrap);
    const tinymceId: string = $wrap.attr("data-editor-id");
    const editor = tinymce.editors[tinymceId];
    if (!editor)
    {
        console.warn(`getWysiwygEditorInstance() failed to find tinymce editor with id: ${tinymceId}`);
        return undefined;
    }
    return editor;
}

if (!window["iw"])
{
    window["iw"] = {};
}

window["iw"].getWysiwygContent = getWysiwygContent;
window["iw"].getWysiwygEditorInstance = getWysiwygEditorInstance;
window["iw"].reinitWysiwygs = reinitWysiwygs;
